import React, { useEffect, useState } from "react";
import T from "prop-types";
import { Row, Col } from "react-bootstrap";
import { Stat } from "MODULES/shared/components";
import numeral from "numeral";
import api from "APP_ROOT/api";

function Count({ data, dataLabel, type, format = "$(0,0)" }) {
  if (!data) return null;

  return (
    <Col md={3}>
      <Stat label={dataLabel} value={numeral(data[type]).format(format)} />
    </Col>
  );
}

Count.propTypes = {
  data: T.shape({}),
  dataLabel: T.string,
  type: T.string
};

function Stats({ partId }) {
  const [stats, setStats] = useState();

  useEffect(() => {
    api.parts.repairOrderLineItems.stats(partId).then(resp => {
      setStats(resp.data);
    });
  }, []);

  if (!stats) return null;

  return (
    <Row>
      <Count
        dataLabel="AVERAGE OVERHAUL"
        data={stats}
        type="overhaul_average"
      />
      <Count dataLabel="AVERAGE REPAIR" data={stats} type="repair_average" />
      <Count dataLabel="AVERAGE TEST" data={stats} type="test_average" />
      <Count
        dataLabel="PASS RATE"
        data={stats}
        type="pass_rate"
        format="0.0%"
      />
      <Count dataLabel="AVERAGE TAT" data={stats} type="tat" format="0 Days" />
    </Row>
  );
}

Stats.propTypes = {};

export default Stats;



// WEBPACK FOOTER //
// ./app/modules/parts/components/RepairOrderLineItems/Stats.jsx